@if (object) {
  <div class="manage-container">
    <div class="left">
      @if (org) {
        @if (object.constructor.name === 'Org') {
          <app-manage-create-org-help [element]="element" [org]="org" />
        }
      }
    </div>
    <div class="right">
      @if (org) {
        @if (object.constructor.name === 'Org') {
          <app-manage-create-org [org]="org" (didSave)="saved($event)" />
        }
      }
    </div>
  </div>
}
